import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

export type AgendaSlotExportDoctolibCsvPayload = {
  id: string;
};

export const agendaSlotExportDoctolibCsv = (
  payload: AgendaSlotExportDoctolibCsvPayload,
) => {
  return http.agendaSlots.exportDoctolibCsv(payload.id).then(({ data }) => {
    return data;
  });
};

const useAgendaSlotExportDoctolibCsvMutation = (): UseMutationResult<
  Blob,
  Error,
  AgendaSlotExportDoctolibCsvPayload
> => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: agendaSlotExportDoctolibCsv,
    onSuccess() {
      toast.success(t('http.agenda-slot-export-doctolib-csv.success'));
    },
  });
};

export default useAgendaSlotExportDoctolibCsvMutation;
